import { Button, Grid, IconButton, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ClearOutlined, HelpOutline } from '@material-ui/icons';
import { FunctionComponent, useState } from 'react';


const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    helpIcon: {
        color: theme.palette.warning.main
    }
}));

type HelpProps = {
    heading?: string
    body: JSX.Element
}

export const Help: FunctionComponent<HelpProps> = ({ heading, body, children }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    return (
        <>
            <Grid container direction="row" alignItems="stretch">
                <Grid item xs={11}>
                    {children}
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        style={{ margin: 2, padding: 0, }}
                        disableRipple={true}
                        disableFocusRipple={true}
                        onClick={() => setOpen(true)}>
                        <HelpOutline className={classes.helpIcon} />
                    </IconButton>
                </Grid>
            </Grid>
            <Modal
                open={open}
                className={classes.modal}
                onClose={() => setOpen(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div className={classes.paper}>
                    <h2><IconButton style={{ color: "red" }} onClick={() => setOpen(false)}><ClearOutlined /></IconButton>{heading || 'Help (সহায়তা)'}</h2>
                    <hr />
                    <p>{body}</p>
                    <Button variant='contained' color='primary' onClick={() => setOpen(false)} style={{ display: 'block', margin: '0 auto' }}>
                        Back (পিছনে)
                    </Button>
                </div>
            </Modal>
        </>
    )
}